import ProxyBaseDAO from "./ProxyBaseDAO";
import CompraCacheModel from "../../model/CompraCacheModel";
import C5PagamentoModel from "../../model/C5PagamentoModel";
import LojaModel from "../../model/LojaModel";
import UsuarioModel from "../../model/UsuarioModel";
import ProdutoModel from "../../model/ProdutoModel";
import C5ProdutoDAO from "../C5/C5ProdutoDAO";
import UsuarioCadastroModel from "../../model/UsuarioCadastroModel";
import LojaOfertasCacheModel from "../../model/LojaOfertasCacheModel";
import WhitelistModel from "../../model/WhitelistModel";
import { CieloCustomer } from "../../model/CieloPagamentoModel";
import UsuarioEnderecoModel from "../../model/UsuarioEnderecoModel";

class ProxyCacheDAO extends ProxyBaseDAO {
  private static instance: ProxyCacheDAO;
  private endpoint = `${super.getBasePath()}`;

  private constructor() {
    super();
  }

  public static getInstance(): ProxyCacheDAO {
    if (!ProxyCacheDAO.instance) {
      ProxyCacheDAO.instance = new ProxyCacheDAO();
    }
    return ProxyCacheDAO.instance;
  }

  public async getCompraDetalhes(compraId: string): Promise<any> {
    return this.get(
      `REQ_PROXY_COMPRA_CACHE_${compraId}`,
      `${this.endpoint}/ConsincoCache/purchase?idConsinco=${compraId}`
    ).then((r: any) => CompraCacheModel.toModel(r.data.data));
  }

  public async getCompreNovamente(
    loja: LojaModel,
    usuario: UsuarioModel
  ): Promise<ProdutoModel[]> {
    if (usuario.documento != null && usuario.documento.length === 0) {
      return Promise.resolve([]);
    }

    const compreNovamente: any = {
      nroempresa: loja.lojaIdOba,
      uf: loja.uf,
      cpfCnpj: usuario.documento,
    };

    return this.get(
      `REQ_COMPRE_NOVAMENTE_${compreNovamente.nroempresa}_${compreNovamente.uf}_${compreNovamente.cpfCnpj}`,
      `${this.endpoint}/Oba/buyAgain?nroEmpresa=${compreNovamente.nroempresa}&uf=${compreNovamente.uf}&cpfCnpj=${compreNovamente.cpfCnpj}`
    ).then((r: any) =>
      r.data.data.map((i: any) =>
        C5ProdutoDAO.getInstance().getBuscaProdutos(
          i.seqproduto,
          i.tipoDesconto,
          loja.lojaId
        )
      )
    );
  }
  
  public async postLojaCache(
    cache: LojaOfertasCacheModel
  ): Promise<any> {
    return this.post(`${this.endpoint}/consincoCache/storeOffers`, cache);
  }

  public async getLojaCache(loja: LojaModel): Promise<LojaOfertasCacheModel> {
    const storeEndpoint: string = `${this.endpoint}/consincoCache/storeOffers?storeId=${loja.lojaId}`;
    return this.get(`REQ_LOJAS_CACHE_${loja.lojaId}`, storeEndpoint).then((ret: any) => LojaOfertasCacheModel.toModel(ret.data.data));
  }

  public async postCompraDetalhes(
    pagamento: C5PagamentoModel,
    msgRetirada: string,
    id: string,
    pagamentoCielo?: any,
    totalCompra?: number,
    cvv?: string,
    customer?: CieloCustomer,
    usuario?: UsuarioModel,
    endereco?: UsuarioEnderecoModel
  ): Promise<any> {
    const obj: CompraCacheModel | null = CompraCacheModel.toModelFromC5(
      pagamento,
      id
    );

    if (obj) {
      let objCompra: any = {};
      if (usuario && endereco) {
        objCompra = CompraCacheModel.toApi(obj, usuario, endereco);
      }
      if (totalCompra && cvv && customer) {
        objCompra = CompraCacheModel.toApiCielo(obj, pagamentoCielo, totalCompra, cvv, customer);
      }

      return this.post(`${this.endpoint}/ConsincoCache/purchase`, {
        ...objCompra,
        deliveryMessage: msgRetirada,
      }).then((r: any) => CompraCacheModel.toModel(r.data));
    }
  }

  public async postDadosUsuario(cadastro: UsuarioCadastroModel): Promise<any> {
    return this.post(
      `${this.endpoint}/ConsincoCache/user-signup`,
      UsuarioCadastroModel.toRecuperarSenha(cadastro)
    );
  }

  public async getWhitelists(usuario: UsuarioModel): Promise<WhitelistModel[]> {
    return this.get(
      `REQ_OBA_WHITELIST`,      
      `${this.endpoint}/Oba/whitelist?userC5ID=${usuario.clienteId}`,
    ).then((r: any) => WhitelistModel.toModelList(r.data.data));
  }
}

export default ProxyCacheDAO;
